module.exports = __webpack_public_path__ + "img/logo_wist.91345172.webp";